import { useCallback } from 'react';
import type { MumulLiveProfileStatus } from 'shared/src/api';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

type LiveProfileBadgeLogParams = {
  /** market.mumul_live_profile_sno */
  profileSno: number;
  profileName: string;
  status: MumulLiveProfileStatus;
  /** LIVE 일 때만 값이 있고 스토리는 null */
  campaignSno: number | null;
};

const TYPE = 'MUMUL_LIVE';

/**
 * 마켓홈 무물라이브 프로필(스토리/라이브) 노출·클릭 로깅.
 * SCREEN / 마켓 defaults 는 MarketAnalyticsProvider 가 자동 주입한다.
 */
export const useLogLiveProfileBadge = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  const buildAnalytics = ({
    profileSno,
    profileName,
    status,
    campaignSno,
  }: LiveProfileBadgeLogParams) => ({
    PROFILE_SNO: profileSno.toString(),
    PROFILE_NAME: profileName,
    PROFILE_STATUS: status,
    CAMPAIGN_SNO: campaignSno != null ? campaignSno.toString() : null,
    TYPE,
  });

  const logDisplayLiveProfileBadge = useCallback(
    (params: LiveProfileBadgeLogParams) => {
      logMarketAnalytics({
        name: 'DISPLAY_LIVE_PROFILE_BADGE',
        analytics: buildAnalytics(params),
      });
    },
    [logMarketAnalytics],
  );

  const logClickLiveProfileBadge = useCallback(
    (params: LiveProfileBadgeLogParams) => {
      logMarketAnalytics({
        name: 'CLICK_LIVE_PROFILE_BADGE',
        analytics: buildAnalytics(params),
      });
    },
    [logMarketAnalytics],
  );

  return { logDisplayLiveProfileBadge, logClickLiveProfileBadge };
};
